/**
 * Shim for `react-native-elements` (only the `Icon` component is used).
 */
import React from 'react';
import VectorIcon from './Icon';

export interface ElementsIconProps {
  name: string;
  type?: string;
  size?: number;
  color?: string;
  onPress?: () => void;
  style?: any;
  [key: string]: any;
}

export const Icon = function Icon({ name, size, color, onPress, style }: ElementsIconProps) {
  return <VectorIcon name={name} size={size} color={color} onPress={onPress} style={style} />;
};

export interface ElementsFabProps {
  title?: string;
  icon?: { name?: string; color?: string } | string;
  color?: string;
  onPress?: () => void;
  disabled?: boolean;
  visible?: boolean;
  placement?: 'left' | 'right';
  style?: any;
  [key: string]: any;
}

export const FAB = function FAB({ title, icon, color = '#00A3E0', onPress, disabled, visible = true, placement, style }: ElementsFabProps) {
  if (!visible) return null;
  const iconName = typeof icon === 'string' ? icon : icon?.name;
  const iconColor = typeof icon === 'object' ? icon?.color : '#fff';
  return (
    <button
      onClick={onPress}
      disabled={disabled}
      style={{
        position: 'absolute',
        bottom: 20,
        [placement === 'left' ? 'left' : 'right']: 20,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        border: 'none',
        borderRadius: title ? 28 : '50%',
        padding: title ? '14px 20px' : 16,
        background: color,
        color: '#fff',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        boxShadow: '0 3px 6px rgba(0,0,0,0.3)',
        ...style,
      }}
    >
      {iconName ? <VectorIcon name={iconName} size={22} color={iconColor} /> : null}
      {title ? <span>{title}</span> : null}
    </button>
  );
};

export default { Icon, FAB };
